import { useAuth } from '../../context/AuthContext';
import { capacidades } from '../../services/permissoes';

/**
 * O que o perfil do usuário pode fazer numa rotina do catálogo (onda O0c, padrão P-S1):
 * { nivel, podeVer, podeIncluir, podeAlterar, podeExcluir }. Use para esconder botões (ex.: "Novo paciente",
 * "Excluir"); a proteção real é do back.
 * @param {string} rotina chave do catálogo (ex.: 'pacientes', 'agenda')
 */
export default function usePermissao(rotina) {
  const { acesso } = useAuth();
  return capacidades(acesso, rotina);
}
